import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

// --- Expanded Data: 52 sample profiles (no changes here) ---
const profiles = [
  { id: 1, name: 'Aarav Sharma', profession: 'Creative Director', image: 'https://picsum.photos/seed/1/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 2, name: 'Saanvi Patel', profession: 'Lead Photographer', image: 'https://picsum.photos/seed/2/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 3, name: 'Vivaan Singh', profession: 'Brand Strategist', image: 'https://picsum.photos/seed/3/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 4, name: 'Kiara Gupta', profession: 'Content Creator', image: 'https://picsum.photos/seed/4/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 5, name: 'Aditya Kumar', profession: 'UI/UX Designer', image: 'https://picsum.photos/seed/5/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 6, name: 'Diya Mehta', profession: 'Frontend Developer', image: 'https://picsum.photos/seed/6/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 7, name: 'Arjun Verma', profession: 'Digital Marketer', image: 'https://picsum.photos/seed/7/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 8, name: 'Ananya Khan', profession: 'SEO Specialist', image: 'https://picsum.photos/seed/8/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 9, name: 'Reyansh Shah', profession: 'Project Manager', image: 'https://picsum.photos/seed/9/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 10, name: 'Pari Jain', profession: 'Social Media Manager', image: 'https://picsum.photos/seed/10/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 11, name: 'Sai Reddy', profession: 'Data Analyst', image: 'https://picsum.photos/seed/11/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 12, name: 'Riya Malhotra', profession: 'Videographer', image: 'https://picsum.photos/seed/12/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 13, name: 'Vihaan Chopra', profession: 'Creative Director', image: 'https://picsum.photos/seed/13/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 14, name: 'Aarohi Iyer', profession: 'Lead Photographer', image: 'https://picsum.photos/seed/14/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 15, name: 'Krishna Naidu', profession: 'Brand Strategist', image: 'https://picsum.photos/seed/15/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 16, name: 'Ahaana Sharma', profession: 'Content Creator', image: 'https://picsum.photos/seed/16/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 17, name: 'Ayaan Patel', profession: 'UI/UX Designer', image: 'https://picsum.photos/seed/17/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 18, name: 'Navya Singh', profession: 'Frontend Developer', image: 'https://picsum.photos/seed/18/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 19, name: 'Ishaan Gupta', profession: 'Digital Marketer', image: 'https://picsum.photos/seed/19/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 20, name: 'Aadya Kumar', profession: 'SEO Specialist', image: 'https://picsum.photos/seed/20/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 21, name: 'Rohan Mehta', profession: 'Project Manager', image: 'https://picsum.photos/seed/21/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 22, name: 'Sneha Verma', profession: 'Social Media Manager', image: 'https://picsum.photos/seed/22/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 23, name: 'Amit Khan', profession: 'Data Analyst', image: 'https://picsum.photos/seed/23/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 24, name: 'Pooja Shah', profession: 'Videographer', image: 'https://picsum.photos/seed/24/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 25, name: 'Vikram Jain', profession: 'Creative Director', image: 'https://picsum.photos/seed/25/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 26, name: 'Anjali Reddy', profession: 'Lead Photographer', image: 'https://picsum.photos/seed/26/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 27, name: 'Deepak Malhotra', profession: 'Brand Strategist', image: 'https://picsum.photos/seed/27/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 28, name: 'Neha Chopra', profession: 'Content Creator', image: 'https://picsum.photos/seed/28/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 29, name: 'Sameer Iyer', profession: 'UI/UX Designer', image: 'https://picsum.photos/seed/29/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
  { id: 30, name: 'Sunita Naidu', profession: 'Frontend Developer', image: 'https://picsum.photos/seed/30/500', linkedin: 'https://www.linkedin.com/', instagram: 'https://www.instagram.com/' },
];


// --- SVG Icons (Replacement for react-icons) ---
const LinkedInIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="0" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
    <rect x="2" y="9" width="4" height="12"></rect>
    <circle cx="4" cy="4" r="2"></circle>
  </svg>
);

const InstagramIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
  </svg>
);


// --- Main Component ---
const ZzayraatConnect = () => {
  const gridRef = useRef(null);

  // --- Effect for scroll-in animation ---
  useEffect(() => {
    const cards = gridRef.current.querySelectorAll('.profile-card');
    const onScroll = () => {
      cards.forEach((card, index) => {
        const rect = card.getBoundingClientRect();
        if (rect.top < window.innerHeight - 100) {
          card.classList.add('show');
          card.style.transitionDelay = `${index * 50}ms`;
        }
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // --- Effect for 3D tilt hover animation ---
  useEffect(() => {
    const cards = gridRef.current.querySelectorAll('.profile-card');
    cards.forEach(card => {
        const handleMouseMove = (e) => {
            const { left, top, width, height } = card.getBoundingClientRect();
            const x = e.clientX - left;
            const y = e.clientY - top;
            const rotateX = -1 * ((height / 2 - y) / (height / 2)) * 15; // Max 15deg rotation
            const rotateY = ((width / 2 - x) / (width / 2)) * -15; // Max 15deg rotation
            card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
        };

        const handleMouseLeave = () => {
            card.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg)';
        };

        card.addEventListener('mousemove', handleMouseMove);
        card.addEventListener('mouseleave', handleMouseLeave);

        return () => {
            card.removeEventListener('mousemove', handleMouseMove);
            card.removeEventListener('mouseleave', handleMouseLeave);
        };
    });
  }, []);


  return (
    <>
      <style>{`
        :root {
          --black: #000000;
          --yellow: #FCDC04;
          --dark-yellow: #C7A900;
          --white: #FFFFFF;
        }
        
        @keyframes aurora {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
        }

        .connect-page {
          min-height: 100vh;
          width: 100%;
          position: relative;
          overflow: hidden;
          background-color: #010101;
          padding: 4rem 1rem;
        }

        .connect-page::before {
            content: '';
            position: absolute;
            top: 0; left: 0; right: 0; bottom: 0;
            background: radial-gradient(circle at 25% 25%, rgba(252, 220, 4, 0.2), transparent 40%),
                        radial-gradient(circle at 75% 75%, rgba(252, 220, 4, 0.2), transparent 40%);
            background-size: 200% 200%;
            animation: aurora 20s linear infinite;
            will-change: background-position;
            z-index: 0;
        }

        .heading {
          color: var(--yellow);
          font-size: 2.5rem;
          text-align: center;
          margin-bottom: 3rem;
          font-family: 'Montserrat', sans-serif;
          font-weight: 700;
          position: relative;
          z-index: 1;
        }

        .profiles-grid {
          display: grid;
          /* Smaller card size */
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 2rem;
          max-width: 1200px;
          margin: 0 auto;
          position: relative;
          z-index: 1;
        }

        .profile-card {
          /* Glassmorphism style */
          background-color: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
          border-radius: 20px;
          border: 1px solid rgba(255, 255, 255, 0.1);
          padding: 1.5rem 1rem;
          color: var(--white);
          text-align: center;
          
          /* Initial animation state */
          opacity: 0;
          transform: perspective(1000px) translateY(40px);
          transition: opacity 0.6s ease-out, transform 0.2s ease, border-color 0.4s ease;
          transform-style: preserve-3d;
        }

        .profile-card.show {
          opacity: 1;
          transform: perspective(1000px) translateY(0);
        }

        .profile-card:hover {
            border-color: var(--yellow);
        }
        
        /* Give card contents some 3D depth */
        .profile-card > * {
            transform: translateZ(20px);
        }

        .profile-img {
          /* Smaller image */
          width: 90px;
          height: 90px;
          border-radius: 50%;
          object-fit: cover;
          margin: 0 auto 1rem;
          border: 3px solid var(--yellow);
        }

        .profile-card h3 {
          color: var(--white);
          /* Smaller font */
          font-size: 1.25rem;
          margin-bottom: 0.2rem;
          font-weight: 600;
        }
        
        .profession {
            color: var(--yellow);
            margin-bottom: 1.25rem;
            font-weight: 500;
            font-size: 0.9rem;
        }

        .profile-icons {
          display: flex;
          justify-content: center;
          gap: 1.25rem;
          margin-bottom: 1.25rem;
        }

        .profile-icons a {
          color: #aaa;
          font-size: 1.4rem;
          transition: color 0.3s ease, transform 0.3s ease;
        }

        .profile-icons a:hover {
          color: var(--yellow);
          transform: scale(1.2) translateZ(20px); /* Add transform for 3D effect */
        }
        
        .collab-btn {
            display: inline-block;
            background-color: var(--yellow);
            color: var(--black);
            padding: 0.6rem 1.5rem; /* Smaller button */
            border-radius: 50px;
            text-decoration: none;
            font-weight: bold;
            font-size: 0.9rem;
            transition: background-color 0.3s ease, transform 0.3s ease;
        }

        .collab-btn:hover {
            background-color: var(--dark-yellow);
            transform: scale(1.05) translateZ(20px); /* Add transform for 3D effect */
        }
      `}</style>
      
      {/* --- JSX Structure --- */}
      <div className="connect-page">
        <h2 className="heading">Zzayraat Collaborators</h2>
        <div className="profiles-grid" ref={gridRef}>
          {profiles.map(profile => (
            <div className="profile-card" key={profile.id}>
              <img src={profile.image} alt={profile.name} className="profile-img" />
              <h3>{profile.name}</h3>
              <p className="profession">{profile.profession}</p>
              <div className="profile-icons">
                <a href={profile.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                  <LinkedInIcon />
                </a>
                <a href={profile.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <InstagramIcon />
                </a>
              </div>
              <Link to="/lets-connect" className="collab-btn">Collaborate</Link>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ZzayraatConnect;